import { z } from 'zod';

import type { TFunction } from 'i18next';

import { refineTerminalMerchantId, terminalFormShape } from './common';

export function createPosTerminalFormSchema(t: TFunction) {
  return z
    .object({
      ...terminalFormShape(t),
      cash_register_id: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') }),
    })
    .superRefine(refineTerminalMerchantId(t));
}

export type PosTerminalFormValues = z.infer<
  ReturnType<typeof createPosTerminalFormSchema>
>;
